import "core-js/modules/es.array.slice.js";
import React from 'react';
import { DefaultIconCompany } from '../../Icon';
import { Badge, BadgeTitle, BadgeImage, BadgeContentImage } from './partials';
export var OrganizationBadge = function OrganizationBadge(_ref) {
  var organization = _ref.organization,
    _ref$large = _ref.large,
    large = _ref$large === void 0 ? false : _ref$large,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'organization' : _ref$type;
  var displayName = organization.displayName,
    icon = organization.icon;
  var words = displayName.split(' ');
  var label = words.slice(0, 2).join(' ');
  return React.createElement(Badge, {
    type: type
  }, icon ? React.createElement(BadgeContentImage, null, React.createElement(BadgeImage, {
    alt: displayName || '',
    src: "https://www.finect.com/image/".concat(icon) || ''
  })) : React.createElement(DefaultIconCompany, {
    nonScaling: false,
    fill: null,
    size: "22"
  }), React.createElement(BadgeTitle, null, large ? displayName : label));
};